import changelogSource from '../../CHANGELOG.md?raw';

export const APP_NAME = 'Slide';
export const APP_VERSION = __APP_VERSION__;
export const COMPANY_DISPLAY_NAME = 'Advanced Substrate Technologies Pte. Ltd.';
export const BUILT_BY = 'AST IT Lab';
export const COPYRIGHT_YEAR = new Date().getFullYear();

export interface ChangelogRelease {
  version: string;
  date: string;
  sections: { title: string; items: string[] }[];
}

/** Parses CHANGELOG.md (`## [x.y.z] - date`, `### Section`, `- item`) into releases, newest first. */
function parseChangelog(source: string): ChangelogRelease[] {
  const releases: ChangelogRelease[] = [];
  for (const line of source.split('\n')) {
    const release = line.match(/^## \[(.+?)\]\s*-\s*(\S+)/);
    if (release) {
      releases.push({ version: release[1], date: release[2], sections: [] });
      continue;
    }
    const current = releases[releases.length - 1];
    if (!current) continue;
    const section = line.match(/^### (.+)/);
    if (section) {
      current.sections.push({ title: section[1].trim(), items: [] });
      continue;
    }
    const item = line.match(/^- (.+)/);
    if (item && current.sections.length) current.sections[current.sections.length - 1].items.push(item[1].trim());
  }
  return releases;
}

export const CHANGELOG = parseChangelog(changelogSource);
